<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" style="stroke: var(--{{variableName}});" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
